module.exports = __webpack_public_path__ + "img/Pinterest.07e271de.png";